const initialState = {
    invoiceItems: [],
    isLoading: false,
    minaylaURL: '',
    customerId: 0,
    isFactoringEnabled: false
};

export const invoiceReducer = (state, action) => {
    state = state || initialState;

    if (action.type === 'INVOICE_GETALL_REQUEST') {
        return {
            ...state,
            startDateIndex: action.startDateIndex,
            isLoading: true,
        };
    }

    if (action.type === 'INVOICE_GETALL_RESPONSE') {
        return {
            ...state,
            startDateIndex: action.startDateIndex,
            isLoading: false,
            invoiceItems: action.invoiceItems,
            minaylaURL: action.minaylaURL,
            customerId: action.customerId,
            isFactoringEnabled: action.isFactoringEnabled
        };
    }

    if (action.type === 'INVOICE_POST_CARD_PAY_REQUEST') {
        return {
            ...state,
            isLoading: true,
        };
    }

    if (action.type === 'INVOICE_POST_CARD_PAY_RESPONSE') {
        return {
            ...state,
            isLoading: false,
        };
    }

    return state;
};


// WEBPACK FOOTER //
// ./src/reducers/InvoiceReducer.js